import { render } from "./unorganizedSetList.vue?vue&type=template&id=2f1fba26&scoped=true"
import script from "./unorganizedSetList.vue?vue&type=script&lang=js"
export * from "./unorganizedSetList.vue?vue&type=script&lang=js"

import "./unorganizedSetList.vue?vue&type=style&index=0&id=2f1fba26&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1fba26"]])

export default __exports__